import { useAuthUrl } from 'features/auth/hooks/useAuthUrl/useAuthUrl';
import authenticatedFetch from 'services/rest/authenticatedFetch';
import { FeatureFlagKey } from 'services/statsig/types';
import { Headers } from 'shared/constants/headers';
import { ClientError } from 'shared/utils/errors';
import { z } from 'zod';

export interface ReactivationResendOtpChallengeData {
  challengeId: string;
}

// Define schema that matches ResendOtpResponse
const resendOtpResponseSchema = z.object({
  message: z.string().optional(),
  errorCode: z
    .union([z.string(), z.number()])
    .transform((value) => Number(value))
    .optional(),
  title: z.string().optional(),
});

// Extract type from schema
export type ResendOtpResponse = z.infer<typeof resendOtpResponseSchema>;

const useReactivationResendOtp = () => {
  const authUrl = useAuthUrl(FeatureFlagKey.RESEND_OTP_USE_K8S_AUTH_SERVICE);

  const reactivationResendOtp = async (
    data: ReactivationResendOtpChallengeData,
    headers?: Headers,
  ) => {
    try {
      const response = await authenticatedFetch(`${authUrl}/resend-otp`, {
        method: 'POST',
        cache: 'no-cache',
        body: JSON.stringify({
          ...data,
        }),
        headers: {
          ...headers,
        },
      });

      const result: unknown = await response.json();

      return resendOtpResponseSchema.parse(result);
    } catch (error) {
      if (error instanceof ClientError && error.responseBody) {
        return resendOtpResponseSchema.parse(error.responseBody);
      }
      throw error;
    }
  };

  return reactivationResendOtp;
};

export default useReactivationResendOtp;
